
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 1.789C0 .8.854 0 1.903 0h20.194C23.147 0 24 .793 24 1.789V14.21C24 15.2 23.146 16 22.097 16H1.903C.853 16 0 15.207 0 14.211V1.79z","fill":"#1171CC"}}),_c('path',{attrs:{"d":"M4.768 8.275h-.692l.692-1.626v.052l.692 1.574h-.692zm5.895.516L9.279 5.669H7.51v4.49l-1.999-4.49H4l-2 4.67h1.206l.41-1.058h2.28l.436 1.058h2.307V6.856l1.512 3.483h1.051l1.538-3.406v3.406h1.128v-4.67h-1.82L10.663 8.79zM18.25 9.346h-2.588v-.93h2.511V7.54h-2.511v-.852h2.588l1.282 1.239-1.282 1.419zm2.717-1.42l.82-.877 1.196-1.367h-1.427L20.275 7.1l-1.282-1.42h-4.485v4.62h4.357l1.359-1.523 1.332 1.548h1.427l-1.196-1.419-.82-.98z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v16H0z"}})])])])
          )
        }
      }
    